import { ApiError, CreateWhitelistDto, Whitelist } from '@36node-fcp/core-sdk';
import { Alert, Form, Input, message, Modal } from 'antd';
import styled from 'styled-components';

import { WhitelistApiErrorMap } from 'src/features/whitelist';
import { useApi } from 'src/lib/react-api';
import { fcp, passFcpApiErrors } from 'src/services';

type EditorValues = CreateWhitelistDto & {};

interface WhitelistEditorProps {
  white?: Whitelist;
  onClose: () => void;
  onFinish?: () => void;
}

export const WhitelistEditor: React.FC<WhitelistEditorProps> = ({
  white,
  onClose: handleClose,
  onFinish: handleFinish,
}) => {
  const [form] = Form.useForm<EditorValues>();

  const isEdit = !!white;
  const onSuccess = () => {
    message.success(isEdit ? '编辑成功' : '创建成功');
    handleClose();
    handleFinish?.();
  };

  const onFailure = (err: ApiError) => {
    const ne = passFcpApiErrors(err, WhitelistApiErrorMap);
    if (ne.keys) {
      ne.keys.forEach((key) => form.setFields([{ name: key, errors: [ne.message[key]] }]));
    } else {
      message.error(ne.message as string);
    }
  };

  const [createState, create] = useApi(fcp.createWhitelist, { onSuccess, onFailure });
  const [updateState, update] = useApi(fcp.updateWhitelist, { onSuccess, onFailure });

  const handleOk = () => form.submit();
  const handleSubmit = async (values: EditorValues) => {
    create({ body: values });
    if (isEdit) {
      update({ whitelistId: white.id, body: values });
    } else {
      create({ body: values });
    }
  };

  const isLoading = updateState.loading || createState.loading;
  const title = isEdit ? '编辑白名单' : '新建白名单';
  const error = updateState.error || createState.error;

  return (
    <Modal title={title} open onOk={handleOk} onCancel={handleClose} confirmLoading={isLoading} width="650px">
      <Container>
        {error && !Object.values(ApiError.Code).includes(error.code) && <Alert message={error.message} type="error" />}
        <Form
          name="whitelist-editor"
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 18 }}
          initialValues={isEdit ? white : { plate: '', plateType: '', remark: '' }}
          autoComplete="off"
          onFinish={handleSubmit}
          form={form}
        >
          <Form.Item hidden={isEdit} label="车牌" name="plate" rules={[{ required: true, message: '请填写车牌' }]}>
            <Input placeholder="填写车牌" />
          </Form.Item>
          <Form.Item
            hidden={isEdit}
            label="号牌类型"
            name="plateType"
            rules={[{ required: true, message: '请填写号牌类型' }]}
          >
            <Input placeholder="填写号牌类型" />
          </Form.Item>
          <Form.Item label="备注" name="remark">
            <Input.TextArea placeholder="填写备注" allowClear />
          </Form.Item>
        </Form>
      </Container>
    </Modal>
  );
};

const Container = styled.div`
  margin: 24px;
`;
